import { Card } from '@/ui/cards/card/Card'
import { BaseSkeleton } from '@/ui/skeleton/BaseSkeleton'
import { TextSkeleton } from '@/ui/skeleton/TextSkeleton'

export function SelectablePointOfSaleCardSkeleton() {
  return (
    <Card padding="md" radius="sm" skin="body-alt" className="flex w-full flex-col gap-4">
      <div className="flex flex-col gap-2">
        <div className="flex justify-between gap-2">
          <TextSkeleton size="lg" className="w-2/3" leading="normal" />
          <TextSkeleton size="md" className="w-1/6" leading="normal" />
        </div>
        <div className="mt-2 flex flex-col gap-0.5">
          <TextSkeleton size="md" className="w-3/4" leading="normal" />
          <TextSkeleton size="md" className="w-1/2" leading="normal" />
        </div>
      </div>
      <BaseSkeleton className="h-6 w-full rounded-sm" />
    </Card>
  )
}
